export default __webpack_public_path__ + "static/media/Woman-1.f15707c3.svg";